









































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { HttpService } from "@/services/api/httpService";
import { OrganisationSubscription } from "@/types/organisationSubscription";
import DatePicker from "@/components/DatePicker.vue";
import { SubscriptionPackageItem } from "@/types/subscriptionPackage";
import moment from "moment";
import {
  required,
  email,
  numeric,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import { ValidationProperties } from "vue/types/vue";
import { SaveMixin } from "@/services/mixins/saveMixin";
import { Organisation } from "../../types/organisation";

const endDateGreaterThanStartDate = (endDate: string, vm: any) => {
  if (!moment(endDate).isValid()) {
    return true;
  }
  return moment(endDate).startOf("day") >= moment(vm.startDate).startOf("day");
};
const dateGreaterThanToday = (date: string, vm: any) => {
  if (!moment(date).isValid()) {
    return true;
  }

  return moment(date).startOf("day") >= moment().startOf("day");
};
@Component({
  components: { DatePicker },
  mixins: [SaveMixin],
  validations: {
    organisationSubscription: {
      subscriptionPackageId: { required },
      trial: { required },
      perpetual: { required },
      suspended: { required },
      startDate: { required },
      endDate: { endDateGreaterThanStartDate },
      notes: { maxLength: maxLength(1000) }
    }
  }
})
export default class OrganisaitonSubscriptionEdit extends Vue {
  showData = false;
  organisationId = "";
  organisationName = "";
  organisationSubscriptionId = "";
  organisationSubscription = new OrganisationSubscription();
  httpServiceSubscription = new HttpService<OrganisationSubscription>();
  httpServiceOrganisationSubscriptions = new HttpService<
    Array<OrganisationSubscription>
  >();
  httpServiceSubscriptionPackages = new HttpService<
    Array<SubscriptionPackageItem>
  >();

  activeSubscriptions = new Array<OrganisationSubscription>();
  allSubscriptions = new Array<SubscriptionPackageItem>();
  filteredSubscriptions = new Array<SubscriptionPackageItem>();
  backRoute = {
    name: "organisationDashboard",
    id: ""
  };
  get title() {
    return `${this.organisationName} - ${this.organisationSubscription.subscriptionPackageName}`;
  }
  async getSubscriptionData() {
    const httpServiceOrganisation = new HttpService<Organisation>();
    const response3 = await httpServiceOrganisation.getItem(
      `organisations/${this.organisationId}`
    );
    this.organisationName = response3.data.organisationName;
    const httpService = new HttpService<SubscriptionPackageItem>();
    const response = await this.httpServiceSubscription.getItem(
      `organisations/${this.organisationId}/subscriptions/${this.organisationSubscriptionId}`
    );

    const response2 = await httpService.getItem(
      `packages/${response.data.subscriptionPackageId}`
    );

    response.data.subscriptionPackageName =
      response2.data.subscriptionPackageName;

    this.organisationSubscription = response.data;

    this.showData = true;
  }

  @Watch("$route", { immediate: true }) getId() {
    this.backRoute.id = this.$route.params.id;
    this.organisationId = this.$route.params.id;
    this.organisationSubscriptionId = this.$route.params.organisationSubscriptionId;
    this.getFilteredSubscriptions();
    this.getSubscriptionData();
    this.organisationSubscription = new OrganisationSubscription();
  }

  async getFilteredSubscriptions() {
    const response = await this.httpServiceOrganisationSubscriptions.getItem(
      `organisations/${this.organisationId}/subscriptions`
    );

    this.activeSubscriptions = response.data;

    await this.httpServiceSubscriptionPackages.getList("packages").then(res => {
      this.allSubscriptions = res.data;
    });

    let activeSubscriptions: any = this.activeSubscriptions;
    this.filteredSubscriptions = this.allSubscriptions.filter(function(
      objFromA: any
    ) {
      return !activeSubscriptions.find(function(objFromB: any) {
        return (
          objFromA.subscriptionPackageId === objFromB.subscriptionPackageId
        );
      });
    });
  }

  save() {
    this.$store.commit("SAVE", false);
    if (!this.$v.$invalid) {
      this.httpServiceSubscription
        .putItem(
          `organisations/${this.organisationId}/subscriptions/${this.organisationSubscriptionId}`,
          this.organisationSubscription
        )
        .then(res => {
          this.$notification.success(`Subscription successfully updated!`);

          this.$router.push({
            name: "organisationDashboard",
            params: { id: this.organisationId }
          });
          this.$store.dispatch("SET_DIRTY", false);
        });
    }
  }
}
